import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import { withRouter } from 'react-router';
import assign from 'lodash/assign';
import Encoding from '../components/Encoding';
import { open } from 'store/modules/modal';
import {
  downloadMedia,
  encode,
  addTone,
  updateTone,
  deleteTone,
  fetchExperiences,
} from '../modules/actions';
import { selected, hasEncodings, hasTones } from '../modules/selectors';
import { isRoot, isAdmin, isUser } from 'store/modules/auth/selectors';

const mapStateToProps = state => ({
  user: state.auth.user,
  experiences: state.cms.experiences,

  // Selectors
  selected: selected(state),
  hasEncodings: hasEncodings(state),
  hasTones: hasTones(state),
  isRoot: isRoot(state),
  isAdmin: isAdmin(state),
  isUser: isUser(state),
});

const mapDispatchToProps = dispatch => ({
  addTone(encoding) {
    dispatch(addTone(encoding));
  },

  encode(encoding) {
    dispatch(encode(encoding));
  },

  downloadMedia(encoding) {
    dispatch(downloadMedia(encoding));
  },

  updateTone(encoding) {
    dispatch(updateTone(encoding));
  },

  confirmDelete(encoding, tone) {
    dispatch(
      open({
        modalType: 'confirm',
        modalProps: {
          message: tone.tone ? `Delete tone ${tone}?` : 'Delete tone?',
          tone,
          handleYes: () => {
            dispatch(deleteTone(encoding, tone));
          },
        },
      })
    );
  },

  fetchExperiences(campaignId) {
    dispatch(fetchExperiences(campaignId));
  },

  setToneNumber(encoding, tone) {
    dispatch(
      open({
        modalType: 'setToneNumber',
        modalProps: {
          tone,
          handleOk: toneNumber => {
            // Update encoding with toneId
            assign(tone, { toneId: toneNumber });
            dispatch(updateTone(encoding));
          },
        },
      })
    );
  },
});

const enhance = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  lifecycle({
    componentDidMount() {
      this.props.history.push('/dashboard');
      this.props.fetchExperiences(this.props.match.params.id);
    },
  })
);

export default enhance(Encoding);
